import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e2ae7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "assets/images/gecoop_logo.png" }, null, -1))
const _hoisted_2 = {
  class: "manual-link",
  href: "https://e.pcloud.link/publink/show?code=XZ5l12ZR8zFH9gLmYQegKeteYy864ilmANV",
  target: "_blank"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "little_logo",
  src: "assets/images/cooperazione_digitale_logo_black.png"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          (!_ctx.isLogin)
            ? (_openBlock(), _createBlock(_component_ion_menu, {
                key: 0,
                "content-id": "main-content",
                type: "reveal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_content, null, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_ion_list, { id: "employee-list" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_list_header, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.userState.user.first_name + ' ' + _ctx.userState.user.last_name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.userState.user.coop_name), 1)
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (p, i) => {
                            return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                              key: i,
                              "auto-hide": "false"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.hasPermission(p.permission))
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 0,
                                      lines: "none",
                                      detail: "false",
                                      class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === i }]),
                                      onClick: ($event: any) => (_ctx.goToPage(i, p.name, 'employee'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          "aria-hidden": "true",
                                          ios: p.iosIcon,
                                          md: p.mdIcon
                                        }, null, 8, ["ios", "md"]),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(p.title), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["class", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_2, [
                                _createVNode(_component_ion_item, {
                                  lines: "none",
                                  detail: "false",
                                  class: "hydrated"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      "aria-hidden": "true",
                                      ios: _ctx.helpCircleOutline,
                                      md: _ctx.helpCircleOutline
                                    }, null, 8, ["ios", "md"]),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Manuale")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_ion_list, {
                            key: 0,
                            id: "admin-list"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_list_header, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Admin")
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminPages, (p, i) => {
                                return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                                  key: i,
                                  "auto-hide": "false"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.hasPermission(p.permission))
                                      ? (_openBlock(), _createBlock(_component_ion_item, {
                                          key: 0,
                                          lines: "none",
                                          detail: "false",
                                          class: _normalizeClass(["hydrated", { selected: _ctx.adminSelectedIndex === i }]),
                                          onClick: ($event: any) => (_ctx.goToPage(i, p.name, 'admin'))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              "aria-hidden": "true",
                                              ios: p.iosIcon,
                                              md: p.mdIcon
                                            }, null, 8, ["ios", "md"]),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(p.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["class", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_menu_toggle, { "auto-hide": "false" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            class: "hydrated",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                "aria-hidden": "true",
                                ios: _ctx.logOutOutline,
                                md: _ctx.logOutOutline
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Logout")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}